
import { createContext } from "react";

export interface IShowLayoutContext {
    showLayout?: boolean;
}

export const ShowLayoutContext = createContext<IShowLayoutContext>({
    showLayout: true
})